angular.module('invoice')
    .controller('InvoiceAccessGroupDialogController', function ($rootScope, $uibModalInstance, data, toastr, InvoiceAccessGroup, InvoiceAccessGroupConst) {
        this.$onInit = () => {
            this.item = data
        }

        this.cancel = () => $uibModalInstance.dismiss()

        this.save = () => {
            let $promise
            if (this.item.id !== null) {
                $promise = InvoiceAccessGroup.update(this.item).$promise
            } else {
                $promise = InvoiceAccessGroup.save(this.item).$promise
            }
            return $promise
                .then(result => {
                    $rootScope.$broadcast(InvoiceAccessGroupConst.eventUpdate)
                    $uibModalInstance.close(result)
                    toastr.success("Zapisano")
                })
        }
    })
